import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDynatraceComponent } from './simple-icons-dynatrace.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDynatraceComponent ],
    exports:      [ SimpleIconsDynatraceComponent ],
    bootstrap:    []
})
export class SimpleIconsDynatraceModule {}
